import component from './WelcomePage.container';

export default component;
